<div id="cutomer-eligibility-screen" (window:orientationchange)="changeOrientation($event)"
    [ngStyle]="{'height.px':divHeight1}">
    <div class="row" [ngStyle]="{'height.px':divHeight1}">
        <div class="col-md-6" id="progress-tracker" [ngStyle]="{'height.px':divHeight1}">
            <div id="heading">
                <h1 *ngIf="showHeading"><strong>{{cfetLabels.cfet_customer_eligibility.heading}}</strong></h1>
                <h1 id="step-done-heading" *ngIf="showStepCompleteHeading">
                    <strong>{{cfetLabels.cfet_customer_eligibility.step_one_complete_heading}}</strong>
                </h1>
                <h1 id="step-done-subheading" *ngIf="showStepCompleteHeading">
                    <strong>{{cfetLabels.cfet_customer_eligibility.step_one_complete_subheading}}</strong>
                </h1>
            </div>
            <div id="all-track">
                <div class="row" id="track1">
                    <div class="col-lg-1" id="circle">
                        <button [ngClass]="stepOneSelected ? 'btn1-selected' : 'btn1'" id="btn1-desc" aria-label="step1"
                            (click)="stepOne()">
                            <p *ngIf="stepOneIcon" id="btn-no">1</p>
                            <p *ngIf="stepOneTickIcon" id="btn-no">&#10003;</p>
                        </button>
                    </div>
                    <div class="col-lg-11" id="text">
                        <p [ngClass]="stepOneSelected ? 'static-text1-selected' : 'static-text'" id="static-text-decs"
                            (click)="stepOne()" (keyup)="stepOne()">{{cfetLabels.cfet_customer_eligibility.eligibility}}
                            <em *ngIf="showDesktopEditButton" class="icon-misc-penL" role="img" aria-label="Edit button"
                                id="icon-role" tabindex="0" (click)="goToEligibility($event)"
                                (keyup)="goToEligibility($event)"></em>
                        </p>
                    </div>
                    <div *ngIf="showMobileEditButton">
                        <em class="icon-misc-penL" role="img" aria-label="Edit Button" id="icon-mobile-role"
                            tabindex="0" (click)="goToEligibility($event)" (keyup)="goToEligibility($event)"></em>
                    </div>
                </div>
                <span [ngClass]="stepOneDone? 'solid-line': 'dashed-line'" id="vertical-line1"></span>
                <div class="row" id="track2">
                    <div class="col-lg-1" id="circle">
                        <button id="btn2-desc" [ngClass]="stepTwoSelected ? 'btn2-selected' : 'btn1' "
                            aria-label="step2" [disabled]="disableStep" (click)="stepTwo()">
                            <p *ngIf="stepTwoIcon" id="btn-no">2</p>
                            <p *ngIf="stepTwoDone" id="btn-no">✔</p>
                        </button>
                    </div>
                    <div class="col-lg-11" id="text">
                        <p [ngClass]="stepTwoSelected ? 'static-text2-selected' : 'static-text'" (click)="stepTwo()"
                            (keyup)="stepTwo()" id="static-text-desc2">
                            {{cfetLabels.cfet_customer_eligibility.information}}</p>
                    </div>
                </div>
                <div [ngClass]="stepTwoDone? 'solid-line': 'dashed-line'" id="vertical-line1" id="vertical-line2"></div>
                <div class="row" id="track3">
                    <div class="col-lg-1" id="circle">
                        <button id="btn3-desc" [ngClass]="stepThreeSelected ? 'btn3-selected' : 'btn1' "
                            aria-label="step3" [disabled]="disableStep" (click)="stepThree()">
                            <p *ngIf="stepThreeIcon" id="btn-no">3</p>
                        </button>
                    </div>
                    <div class="col-lg-11" id="text">
                        <p [ngClass]="stepThreeSelected ? 'static-text3-selected' : 'static-text'" (click)="stepThree()"
                            (keyup)="stepThree()" id="static-text-desc3">
                            {{cfetLabels.cfet_customer_eligibility.profile}}</p>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-md-6" id="form-component-section">
            <div class="row">
                <div class="col-md-2"></div>
                <div class="col-md-8">
                    <app-customer-eligibility-form *ngIf="showEligibilitySection"
                        [editButtonClicked]="editButtonClicked"
                        (eligibilitycompletionstatus)="onEligibilityCompletion($event)"
                        (editSelected)="onEligibilityCompletion($event)" (showCancelModal)="cancelModal($event)">
                    </app-customer-eligibility-form>
                </div>
                <div class="col-md-2"></div>
            </div>
        </div>
    </div>

    <div [ngClass]="showCancelModal ? 'cancel-modal' : ''">
        <app-cancel-modal [openModal]="openCancelModal" (closeModal)="closeModal($event)">
        </app-cancel-modal>
    </div>
</div>